import { z } from 'zod'

export const trainerResourceScheduledProbeExceptionResponseSchema = z.record(z.unknown())
export type TrainerResourceScheduledProbeExceptionResponse = z.infer<typeof trainerResourceScheduledProbeExceptionResponseSchema>
